import styled from '@emotion/styled';
import { TipsAndUpdatesOutlined } from '@mui/icons-material';

import {
  blueBlack500,
  blueUltramarine200,
} from '../../theme/videa-style-tokens';

export const Card = styled.div`
  padding: 1em;
  box-sizing: border-box;
  display: flex;
  border-radius: 0.75em;
  width: 100%;
  max-width: 25em;
  background-color: ${blueBlack500};
  flex-direction: column;
  justify-content: space-between;
  &.padding-bottom {
    padding-bottom: 2em;
  }
`;

export const SubCard = styled.div`
  background-color: white;
  border-radius: 0.5em;
  padding: 1.75em;
  display: flex;
  flex-direction: column;
  gap: 0.5em;
`;

export const TipsAndUpdatesOutlinedIcon = styled(TipsAndUpdatesOutlined)`
  fill: ${blueUltramarine200};
  font-size: 1.375em;
`;

export const Flex = styled.div`
  display: flex;
  gap: 1em;
  &.center {
    align-items: center;
    justify-content: center;
  }
  &.align-center {
    align-items: center;
  }
  &.barCharts {
    align-items: end;
    justify-content: center;
  }
  &.space-between {
    justify-content: space-between;
  }
  &.column {
    flex-direction: column;
  }
  &.barColumn {
    flex-direction: column;
    align-items: center;
  }
  &.left-margin {
    margin-left: 1em;
  }
`;
